module.exports = __webpack_public_path__ + "img/Notisphere_Icon_Block_Color_Light.c0d5e472.png";